package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class UsageSummaryDto(
    val creditsUsed: Int,
    /** Null when the deployment has no monthly limit. */
    val creditsLimit: Int? = null,
    /** Bought credit packs; they never expire and are spent after the monthly credits. */
    val purchasedCredits: Int = 0,
    val periodEndsAtMs: Long,
    val creditCosts: Map<String, Int> = emptyMap()
)
